export const SET_STORE = "SET_STORE";
